<div id="sticky-content" class="sticky-content">
  <!-- desktop -->
  <div class="flex flex-col gap-[32px] lt-lg:!hidden">
    <div>
      <button
        mat-stroked-button
        color="accent"
        appLargeButton
        [routerLink]="['/installations']"
        gtm="onBreadcrumbBack"
        gtmCategory="installationDetails"
      >
        <mat-icon>arrow_back</mat-icon>
        <span>{{ 'GENERAL.PATH.INSTALLATIONS' | translate }}</span>
      </button>
    </div>

    <div
      *ngIf="installationDetailsStore.ownershipType$ | async as ownershipType"
      class="flex flex-col gap-[8px]"
    >
      <app-installation-card
        *ngIf="
          ownershipType === OwnershipType.CommercialV1 ||
          ownershipType === OwnershipType.CommercialV2
        "
      ></app-installation-card>
      <app-owner-card></app-owner-card>
      <ng-container
        *ngIf="
          (remoteConfigStore.hasAccessToProPlusFeaturesByVkOrg$ | async) ||
          (remoteConfigStore.hasAccessToProPlusFeaturesByCompanyId$ | async)
        "
      >
        <app-booked-package-card *appHideForRsaUser></app-booked-package-card>
      </ng-container>

      <ng-container *appHideForRsaUser>
        <app-building-manager-card
          *ngIf="isInstallationVitocrossalNAType && ownershipType === OwnershipType.CommercialV1"
        ></app-building-manager-card>
      </ng-container>

      <!--     Holiday mode cards     -->
      <ng-container *ngIf="isMultiFamily">
        <ng-container *ngFor="let circuit of availableCircuits">
          <app-holiday-card
            data-at-holiday-program-card
            *ngIf="circuit"
            [circuitId]="circuit"
            [isMultiFamily]="isMultiFamily"
          >
          </app-holiday-card>
          <app-holiday-card
            data-at-holiday-at-home-card
            *ngIf="circuit"
            [circuitId]="circuit"
            [isMultiFamily]="isMultiFamily"
            [isHolidayAtHome]="true"
          >
          </app-holiday-card>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!isMultiFamily">
        <app-holiday-card
          data-at-holiday-program-card
          *ngIf="(firstCircuitId$ | async) || (holidayProgram$ | async | ready)"
          [circuitId]="firstCircuitId$ | async"
        >
        </app-holiday-card>
        <app-holiday-card
          data-at-holiday-at-home-card
          *ngIf="firstCircuitId$ | async as firstCircuitId"
          [circuitId]="firstCircuitId$ | async"
          [isHolidayAtHome]="true"
        >
        </app-holiday-card>
      </ng-container>
      <ng-container *appHideForNoDashboardFeature>
        <app-note-card *appHideForCompanyUser></app-note-card>
      </ng-container>
      <app-active-errors-card *appHideForNoDashboardFeature></app-active-errors-card>
      <app-remote-service-card
        *ngIf="installationDetailsStore.isPermanentInspectionMenuItemVisible() | async"
      ></app-remote-service-card>
    </div>
  </div>

  <!-- mobile -->
  <div class="lt-md:gap-[8px] md:gap-[16px] !hidden lt-lg:!flex lt-lg:flex-col">
    <div class="flex flex-row justify-between items-center">
      <div class="flex flex-row justify-start items-center lt-sm:flex-[48px] lt-sm:max-w-[48px]">
        <button
          class="nav-button"
          mat-stroked-button
          color="accent"
          appLargeButton
          [routerLink]="['/installations']"
          gtm="onBreadcrumbBack"
          gtmCategory="installationDetails"
        >
          <mat-icon>arrow_back</mat-icon>
          <span class="nav-button-text">{{ 'GENERAL.PATH.INSTALLATIONS' | translate }}</span>
        </button>
      </div>
      <div class="flex flex-col justify-center items-center flex-[100%] max-w-[50%]">
        <app-owner-name-panel></app-owner-name-panel>
        <app-holiday-icon [isMultiFamily]="isMultiFamily"></app-holiday-icon>
      </div>
      <div class="flex flex-row justify-end items-center lt-sm:flex-[48px] lt-sm:max-w-[48px]">
        <button
          class="nav-button toggle-button"
          mat-stroked-button
          color="accent"
          appLargeButton
          (click)="toggle()"
        >
          <span class="nav-button-text">
            {{
              isExpanded
                ? ('GENERAL.BUTTON.CLOSE_DETAILS' | translate)
                : ('GENERAL.BUTTON.SHOW_DETAILS' | translate)
            }}
          </span>
          <mat-icon [@arrowRotate]="expandedState"> expand_more</mat-icon>
        </button>
      </div>
    </div>
    <div *ngIf="isExpanded" [@toggle] class="grid-column" [class.isSafari]="isSafari">
      <div class="grid-column">
        <app-installation-card></app-installation-card>
        <app-owner-card></app-owner-card>
        <ng-container
          *ngIf="
            (remoteConfigStore.hasAccessToProPlusFeaturesByVkOrg$ | async) ||
            (remoteConfigStore.hasAccessToProPlusFeaturesByCompanyId$ | async)
          "
        >
          <app-booked-package-card *appHideForRsaUser></app-booked-package-card>
        </ng-container>

        <ng-container *appHideForRsaUser>
          <app-building-manager-card
            *ngIf="
              isInstallationVitocrossalNAType &&
              (installationDetailsStore.ownershipType$ | async) === OwnershipType.CommercialV1
            "
          ></app-building-manager-card>
        </ng-container>

        <!-- Holiday mode cards -->
        <ng-container *ngIf="isMultiFamily">
          <ng-container *ngFor="let circuit of availableCircuits">
            <app-holiday-card
              data-at-holiday-program-card
              *ngIf="circuit"
              [circuitId]="circuit"
              [isMultiFamily]="isMultiFamily"
            >
            </app-holiday-card>
            <app-holiday-card
              data-at-holiday-at-home-card
              *ngIf="circuit"
              [circuitId]="circuit"
              [isMultiFamily]="isMultiFamily"
              [isHolidayAtHome]="true"
            >
            </app-holiday-card>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!isMultiFamily">
          <app-holiday-card
            data-at-holiday-program-card
            *ngIf="firstCircuitId$ | async as firstCircuitId"
            [circuitId]="firstCircuitId$ | async"
          >
          </app-holiday-card>
          <app-holiday-card
            data-at-holiday-at-home-card
            *ngIf="firstCircuitId$ | async as firstCircuitId"
            [circuitId]="firstCircuitId$ | async"
            [isHolidayAtHome]="true"
          >
          </app-holiday-card>
        </ng-container>
        <app-note-card *appHideForCompanyUser></app-note-card>
      </div>
      <div class="grid-column">
        <app-active-errors-card></app-active-errors-card>
      </div>
      <div
        *ngIf="installationDetailsStore.isPermanentInspectionMenuItemVisible() | async"
        class="grid-column"
      >
        <app-remote-service-card></app-remote-service-card>
      </div>
    </div>
  </div>
</div>
